import { Box, Drawer } from '@mui/material';
import { FC, ReactNode } from 'react';
import { useShowDrawer } from '../../contexts';

type Props = {
    children?: ReactNode;
};

export const SideBar: FC<Props> = ({ children }) => {
    const { showDrawer, setShowDrawer } = useShowDrawer();
    const handleDrawerToggle = () => {
        setShowDrawer(!showDrawer);
    };

    return (
        <Box>
            <Drawer
                sx={{ '.MuiDrawer-paper': { top: 55, pb: 6 }, display: { xs: 'block', lg: 'none' } }}
                variant="temporary"
                open={showDrawer}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                <Box onClick={handleDrawerToggle}>{children}</Box>
            </Drawer>

            <Drawer
                sx={{ '.MuiDrawer-paper': { top: 55, pb: 6 }, display: { xs: 'none', lg: 'block' } }}
                variant="persistent"
                open
            >
                <Box>{children}</Box>
            </Drawer>
        </Box>
    );
};
